import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW7402Model } from "../kymw7402.model";

/** レスポンス構造 */
export type GetRememberOrderNumResponce = {
  OrderNum: string;
  OrderChangeOrderNum: string;
}

/**
 * 忘れず注文コード自動付番取得
 * 
 */
@Injectable()
export class GetRememberOrderNumService extends PlessJsonResponderSub<GetRememberOrderNumResponce> {

  private model: KYMW7402Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   * 
   */
  private getBody() {
    return new PlessRequest({
      parameter: {
        OrderReceptionStartCatalog: this.model.orderReceptionStartCatalog,
      }
    })
  }

  /**
   * API呼び出し
   * @param model 
   * @param successFunc 
   */
  execute(model: KYMW7402Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getRememberOrderNum', this.getBody());
  }

  /**
   * API通信成功時の処理
   * @param data 
   */
  success(data: GetRememberOrderNumResponce): void {
    if ( data !== null ) {
      this.model.orderNum = data.OrderNum;
      this.model.orderChangeOrderNum = data.OrderChangeOrderNum;
    }
    if ( this.successFunc !== null ) {
      this.successFunc();
    }
  }
}